<div class="card shadow-sm mb-10">
    <div class="card-header collapsible cursor-pointer" (click)="isCollapsed = !isCollapsed; toggle.emit(!isCollapsed)">
        <h3 class="card-title">{{ title }}</h3>
        <div class="card-toolbar" [ngClass]="{ 'rotate-180': !isCollapsed }">
            <i class="ki-duotone ki-down fs-1"></i>
        </div>
    </div>
    <div id="kt_docs_card_collapsible" [ngbCollapse]="isCollapsed">
        <div class="card-body">
            <ng-content></ng-content>
        </div>
    </div>
</div>